import router from './router'
import useSupportStore from './store'
import SupportMessages from './localization'

export default {
  router,
  useSupportStore,
  localization: SupportMessages,
}
